import { type FC, type ReactNode } from "react"

import LexicalViewer from "@forento/shared-client/components/LexicalViewer"

type Props = {
	thumbnailUrl?: string | null
	title: string
	tags?: { id: number; label: string }[]
	description?: string
	htmlDescription?: string
	callToAction: ReactNode
}
const Hero: FC<Props> = ({ thumbnailUrl, title, tags, description, htmlDescription, callToAction }) => (
	<div className="mb-8 flex flex-col flex-wrap items-center gap-4 bg-white p-6 py-16 shadow lg:flex-row lg:gap-10 lg:px-20">
		<div className="flex grow flex-col gap-4 lg:flex-row lg:items-center lg:gap-10">
			{thumbnailUrl && (
				<div className="max-h-sm flex w-full max-w-sm items-center justify-center lg:max-w-2xs lg:justify-start">
					<img alt="Product thumbnail" src={thumbnailUrl} className="max-h-full max-w-full" />
				</div>
			)}
			<div className="flex grow flex-col gap-4 lg:gap-6">
				<h2 className="font-quicksand text-xl font-bold">{title}</h2>
				{description && <p className="text-sm">{description}</p>}
				{htmlDescription && <LexicalViewer html={htmlDescription} className="shrink" />}
				{tags && tags.length > 0 && (
					<div className="flex flex-wrap gap-2 self-center lg:self-start">
						{tags.map(tag => (
							<div
								key={tag.id}
								className="inline-flex items-center rounded-full bg-primary/10 px-4 py-2 text-sm font-medium text-primary"
							>
								<span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary/60" />
								{tag.label}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
		<div className="justify-end self-center">{callToAction}</div>
	</div>
)

export default Hero
